// Re-exports the shared dashboard-page styled-components plus ParentDashboard's
// own ButtonWrapper / ButtonLink (which TeacherDashboard doesn't need).
// Source: src/app/components/shared/dashboardPageStyles.js
import styled from 'styled-components'

export * from 'app/components/shared/dashboardPageStyles'

export const ButtonWrapper = styled.div`
  display: contents;
`

export const ButtonLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
`
